export default "__VITE_ASSET__0080a24d__"